/**
 * badge.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

export interface OverlayEntry {
  name : string;
  image : string;
}

export interface BadgeEntry {
  report : string;
  image : string;
  overlay? : string;
}

export class Badge {

  constructor (
    public name : string,
    public url : string,
    public overlay : string | null = null,
    public overlayUrl : string | null = null,
    public knownType : boolean = true
  ) {
    //
  }

  public static UNKNOWN : Badge = new Badge("", "", null, null, false);
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/intake-form/badge.ts